import React from "react"
import { Form } from "react-bootstrap"

const PageSection = ({ children }) => {
  return <Form.Group className="mb-4">{children}</Form.Group>
}

export default PageSection
